import { actions } from "../framework/actions"

const sendConfirmationEmail = (apiSendConfirmationEmail, dispatch) => async ({
  email,
}) => {
  const response = await apiSendConfirmationEmail(email)
  const resultAction = response.error
    ? actions.sendConfirmationEmailFailure({ error: response })
    : actions.sendConfirmationEmailSuccess()
  return dispatch(resultAction)
}

export default sendConfirmationEmail
